import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Observable, map, tap } from 'rxjs';
import { GroupDto } from '@oracychampions/api-interfaces';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { tablerArrowLeft } from '@ng-icons/tabler-icons';

@Component({
  selector: 'oc-group-container',
  standalone: true,
  imports: [CommonModule, RouterModule, NgIconComponent],
  providers: [
    provideIcons({
      tablerArrowLeft,
    }),
  ],
  template: `
    <div class="d-flex">
      <div class="oc-menu">
        <div>
          <a [routerLink]="['/dashboard']" class="mt-1 mb-3 btn btn-secondary btn-rounded"
            ><ng-icon name="tablerArrowLeft" size="20"></ng-icon> Dashboard</a
          >
          <select class="form-select mt-3 mb-4 oc-menu-selector" aria-label="Menu" (change)="onMenuChange($event)">
            <option
              *ngFor="let group of groups$ | async"
              [value]="group.id"
              [selected]="group.id === (group$ | async)!.id"
            >
              {{ group.name }}
            </option>
          </select>
          <ul class="list-group">
            <a class="list-group-item list-group-item-action" routerLinkActive="active" [routerLink]="['feed']"
              >Recordings</a
            >
            <a
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              routerLinkActive="active"
              [routerLink]="['students']"
              ><div>Students</div>
              <span class="badge text-bg-primary rounded-pill">{{ (group$ | async)?.students?.length ?? 0 }}</span></a
            >
            <a
              class="list-group-item list-group-item-action  d-flex justify-content-between align-items-center"
              routerLinkActive="active"
              [routerLink]="['users']"
              ><div>Teachers</div>
              <span class="badge text-bg-primary rounded-pill">{{ (group$ | async)?.users?.length ?? 0 }}</span></a
            >
          </ul>
        </div>
      </div>
      <div class="flex-grow-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: ``,
})
export class GroupContainerComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  public groups$: Observable<GroupDto[]>;
  public group$: Observable<GroupDto>;
  public groupId: string;

  constructor() {
    this.groups$ = this.route.data.pipe(
      map((data) => data['groups']),
      map((groups) => {
        return groups
          .sort((a: any, b: any) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .sort((a: any, b: any) => {
            return a.year - b.year;
          });
      }),
    );
    this.group$ = this.route.data.pipe(
      map((data) => data['group']),
      tap((group) => (this.groupId = group.id)),
    );
    this.groupId = this.route.snapshot.params['id'];
  }

  onMenuChange(event: Event) {
    const groupId = (event.target as HTMLSelectElement).value;
    this.router.navigate(['/group', groupId]);
  }
}
